import { useState, useRef, useEffect } from "react";
import {
  ChevronDown,
  ChevronUp,
  ClipboardList,
  Home,
  List,
  LogOut,
  Package,
  ScrollText,
  UserCircle,
  UserRound,
  Users,
} from "lucide-react";
import { clearToken } from "../store/slices/authSlice";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./../styles/UserMenu.css";
import { Usuario } from "../types/types";

const UserMenu = ({ user }: { user: Usuario | null }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(clearToken());
    navigate("/");
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  let routes = [];

  if (user?.nivel === "1") {
    routes = [
      { path: "/", label: "Início", icon: <Home size={16} /> },
      {
        path: "/estoque",
        label: "Estoque",
        icon: <Package size={16} />,
      },
      {
        path: "/cadastramento",
        label: "Cadastramento",
        icon: <Users size={16} />,
      },
      {
        path: "/solicitacoes-compra",
        label: "Solicitação de Compra",
        icon: <ClipboardList size={16} />,
      },
      { path: "/chamados", label: "Chamados", icon: <List size={16} /> },
      {
        path: "/checklists",
        label: "Checklists",
        icon: <ScrollText size={16} />,
      },
      {
        path: "/perfil",
        label: "Perfil",
        icon: <UserRound size={16} />,
      },
    ];
  } else {
    routes = [
      { path: "/", label: "Início", icon: <Home size={16} /> },
      {
        path: "/chamado",
        label: "Abrir chamado",
        icon: <ClipboardList size={16} />,
      },
      { path: "/chamados", label: "Meus Chamados", icon: <List size={16} /> },
    ];
  }

  return (
    <div className="user-menu" ref={menuRef}>
      <button className="user-button" onClick={() => setIsOpen(!isOpen)}>
        <span className="me-2 d-none d-sm-inline" style={{ fontSize: "13px" }}>
          Olá, {user?.nome?.split(" ")[0] || "Usuário"}
        </span>

        <span className="me-2 d-inline d-sm-none" style={{ fontSize: "12px" }}>
          {user?.nome?.split(" ")[0]}
        </span>

        <UserCircle size={32} />
        {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
      </button>

      {isOpen && (
        <div className="user-dropdown">
          <div className="user-info">
            Nível: {user?.nivel === "2" ? "Cliente" : "Técnico"}
          </div>
          <ul>
            {routes.map(({ path, label, icon }) =>
              window.location.pathname !== path ? (
                <li key={path} onClick={() => navigate(path)}>
                  {icon} {label}
                </li>
              ) : null,
            )}
            <li onClick={handleLogout} className="logout">
              <LogOut size={16} /> Sair
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
